export function addDestroyableEventListener(target, evType, listener) {
    target.addEventListener(evType, listener);
    return target.removeEventListener.bind(target, evType, listener);
}
